/* ==========================================================================
   Maison — Theme JavaScript (vanilla, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, settings: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.settings.moneyFormat || '${{amount}}';
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  /* ---------- Overlay / scroll lock ---------- */
  var overlay = $('[data-overlay]');
  var openLayers = [];
  function lock() { document.body.classList.add('is-locked'); if (overlay) overlay.classList.add('is-visible'); }
  function unlock() { if (openLayers.length) return; document.body.classList.remove('is-locked'); if (overlay) overlay.classList.remove('is-visible'); }
  function closeAll() {
    openLayers.slice().forEach(function (el) { closeLayer(el); });
  }
  function openLayer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (openLayers.indexOf(el) === -1) openLayers.push(el);
    lock();
    var focusable = el.querySelector('input[type="search"], [data-drawer-close], [data-modal-close], button, a');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 350);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openLayers = openLayers.filter(function (l) { return l !== el; });
    unlock();
  }
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeLightbox(); } });

  /* ---------- Bottom-sheet drag to close (mobile) ---------- */
  (function () {
    var sheet = null, startY = 0, dy = 0;
    document.addEventListener('touchstart', function (e) {
      var h = e.target.closest('[data-sheet-handle]');
      if (!h || e.target.closest('button:not([data-sheet-handle])')) return;
      var d = h.closest('[data-drawer]');
      if (!d || !window.matchMedia('(max-width: 749px)').matches) return;
      sheet = d; startY = e.touches[0].clientY; dy = 0;
      d.classList.add('is-dragging');
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!sheet) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      sheet.style.setProperty('--drag', dy + 'px');
    }, { passive: true });
    document.addEventListener('touchend', function () {
      if (!sheet) return;
      var d = sheet; sheet = null;
      d.classList.remove('is-dragging');
      if (dy > 110) closeLayer(d);
      d.style.removeProperty('--drag');
    });
  })();

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-drawer-open]'))) {
      e.preventDefault();
      openLayer(document.getElementById(el.getAttribute('data-drawer-open')));
      return;
    }
    if ((el = t.closest('[data-drawer-close]'))) {
      closeLayer(el.closest('[data-drawer]'));
      return;
    }
    if ((el = t.closest('[data-cart-open]'))) {
      if (T.settings.cartType === 'drawer' && !document.querySelector('[data-main-cart]')) {
        e.preventDefault();
        openLayer($('[data-cart-drawer]'));
      }
      return;
    }
    if ((el = t.closest('[data-modal-open]'))) {
      e.preventDefault();
      openLayer(document.getElementById(el.getAttribute('data-modal-open')));
      return;
    }
    if ((el = t.closest('[data-modal-close]'))) {
      closeLayer(el.closest('[data-modal]'));
      return;
    }
    if (t.matches('[data-modal]')) { closeLayer(t); return; }
    if ((el = t.closest('[data-search-open]'))) { e.preventDefault(); openSearch(); return; }
    if ((el = t.closest('[data-search-close]'))) { closeLayer($('[data-search-drawer]')); return; }
    if ((el = t.closest('[data-quick-view]'))) { e.preventDefault(); quickView(el.getAttribute('data-quick-view')); return; }
    if ((el = t.closest('[data-quick-add-id]'))) {
      e.preventDefault();
      el.classList.add('is-loading');
      addToCart({ items: [{ id: Number(el.getAttribute('data-quick-add-id')), quantity: 1 }] })
        .finally(function () { el.classList.remove('is-loading'); });
      return;
    }
    if ((el = t.closest('[data-copy-link]'))) {
      e.preventDefault();
      var link = el.getAttribute('data-copy-link');
      if (navigator.clipboard) navigator.clipboard.writeText(link).then(function () { toast(T.strings.linkCopied); });
      return;
    }
    if ((el = t.closest('[data-copy-code]'))) {
      e.preventDefault();
      var code = el.getAttribute('data-copy-code');
      var done = function () { el.classList.add('is-copied'); toast(T.strings.codeCopied + ' ' + code); setTimeout(function () { el.classList.remove('is-copied'); }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      return;
    }
    if ((el = t.closest('[data-back-to-top]'))) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    if ((el = t.closest('[data-toggle-recover]'))) {
      e.preventDefault();
      var lp = $('[data-login-panel]'), rp = $('[data-recover-panel]');
      if (lp && rp) { lp.classList.toggle('hidden'); rp.classList.toggle('hidden'); }
      return;
    }
  });

  /* ==========================================================================
     CART
     ========================================================================== */
  var CART_SECTIONS = 'cart-drawer';

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
    $$('[data-cart-drawer-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }

  function renderCartDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var count = doc.querySelector('[data-cart-drawer-count]');
    if (count) updateCartCount(parseInt(count.textContent, 10) || 0);
  }

  function refreshCart() {
    return fetch(T.routes.root + '?sections=' + CART_SECTIONS, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCartDrawer(data['cart-drawer']); });
  }

  function addToCart(body, opts) {
    opts = opts || {};
    body.sections = CART_SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Error');
        var chain = Promise.resolve();
        if (opts.discount) {
          chain = fetch('/discount/' + encodeURIComponent(opts.discount), { credentials: 'same-origin' }).catch(function () {});
        }
        return chain.then(function () {
          if (T.settings.cartType === 'page') { window.location.href = T.routes.cart; return; }
          var after = opts.discount ? refreshCart() : Promise.resolve(renderCartDrawer(res.json.sections && res.json.sections['cart-drawer']));
          return after.then(function () {
            closeLayer($('#QuickView'));
            openLayer($('[data-cart-drawer]'));
          });
        });
      });
  }

  function changeLine(line, quantity) {
    var drawer = $('[data-cart-drawer]');
    var mainCart = $('[data-main-cart]');
    var item = document.querySelector('.cart-item[data-line="' + line + '"]');
    if (item) item.classList.add('is-loading');
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: CART_SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) { toast(cart.description || cart.message); if (item) item.classList.remove('is-loading'); return; }
        if (mainCart) { window.location.reload(); return; }
        renderCartDrawer(cart.sections && cart.sections['cart-drawer']);
        updateCartCount(cart.item_count);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    var rm = e.target.closest('[data-cart-remove]');
    if (!btn && !rm) return;
    var item = (btn || rm).closest('.cart-item');
    if (!item) return;
    e.preventDefault();
    changeLine(Number(item.getAttribute('data-line')), rm ? 0 : Math.max(0, Number(btn.getAttribute('data-cart-qty'))));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty-input]')) {
      var item = e.target.closest('.cart-item');
      changeLine(Number(item.getAttribute('data-line')), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
    if (e.target.matches('[data-cart-note]')) {
      fetch(T.routes.cartUpdate + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    }
  });

  /* Intercept product forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var invalid = Array.prototype.find.call(form.elements, function (el) { return el.required && !el.checkValidity(); });
    if (invalid) { invalid.reportValidity(); invalid.focus(); return; }
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (err) err.classList.add('hidden');

    var fd = new FormData(form);
    var id = Number(fd.get('id'));
    var qty = Number(fd.get('quantity') || 1);
    var discount = null;
    var section = form.closest('[data-product-section]');
    if (section) {
      var br = section.querySelector('[data-qty-breaks] input:checked');
      if (br && br.getAttribute('data-code')) discount = br.getAttribute('data-code');
    }
    var item = { id: id, quantity: qty };
    var sp = fd.get('selling_plan');
    if (sp) item.selling_plan = sp;
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;

    var items = [item];
    var gift = section && section.querySelector('[data-gift-toggle] input:checked');
    if (gift) {
      var gp = {}; gp[gift.getAttribute('data-gift-key') || '_gift'] = gift.getAttribute('data-gift-value') || 'Gift';
      items.push({ id: Number(gift.getAttribute('data-gift-variant')), quantity: 1, properties: gp });
    }
    addToCart({ items: items }, { discount: discount })
      .catch(function (error) {
        if (err) { err.textContent = error.message; err.classList.remove('hidden'); } else { toast(error.message); }
      })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
  });

  /* ==========================================================================
     SEARCH
     ========================================================================== */
  function openSearch() {
    var d = $('[data-search-drawer]');
    openLayer(d);
    var input = d && d.querySelector('[data-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 300);
  }
  (function () {
    var input = $('[data-search-input][data-predictive]');
    if (!input) return;
    var results = $('[data-search-results]');
    var def = $('[data-search-default]');
    var timer, ctrl;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (!q) { results.innerHTML = ''; if (def) def.classList.remove('hidden'); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        fetch(url, { signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = doc.querySelector('.shopify-section') || doc.body;
            results.innerHTML = sec.innerHTML;
            if (def) def.classList.add('hidden');
          })
          .catch(function () {});
      }, 250);
    });
  })();

  /* ==========================================================================
     QUICK VIEW
     ========================================================================== */
  function quickView(url) {
    var modal = $('#QuickView');
    if (!modal) { window.location.href = url; return; }
    var content = modal.querySelector('[data-quick-view-content]');
    content.innerHTML = '<div class="spinner"></div>';
    openLayer(modal);
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=quick-view')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('.product-compact');
        content.innerHTML = node ? node.outerHTML : '';
        var el = content.querySelector('[data-product-section]');
        if (el) new Product(el, { updateUrl: false });
      });
  }

  /* ==========================================================================
     PRODUCT
     ========================================================================== */
  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function Product(el, opts) {
    this.el = el;
    this.opts = opts || {};
    var json = el.querySelector('[data-product-json]');
    if (!json) return;
    try { this.product = JSON.parse(json.textContent); } catch (e) { return; }
    var inv = el.querySelector('[data-inventory-json]');
    try { this.inventory = inv ? JSON.parse(inv.textContent) : {}; } catch (e) { this.inventory = {}; }
    this.picker = el.querySelector('[data-variant-picker]');
    this.idInput = el.querySelector('[data-variant-id]');
    this.variant = this.product.variants.find(function (v) { return String(v.id) === String(this.idInput ? this.idInput.value : ''); }, this) || this.product.variants[0];
    this.initGallery();
    this.initQty();
    this.initBreaks();
    if (this.picker) {
      this.picker.addEventListener('change', this.onChange.bind(this));
      this.markAvailability(this.currentOptions());
    }
    this.initSticky();
    this.initDelivery();
    this.initComplementary();
    this.initGift();
    this.filterMedia(true);
    if (this.opts.updateUrl !== false) this.trackRecentlyViewed();
  }

  Product.prototype.currentOptions = function () {
    return $$('[data-option-index]', this.picker).map(function (fs) {
      var sel = fs.querySelector('select');
      if (sel) return sel.value;
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  };

  Product.prototype.findVariant = function (options) {
    return this.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    });
  };

  Product.prototype.markAvailability = function (selected) {
    var variants = this.product.variants;
    $$('[data-option-index]', this.picker).forEach(function (fs) {
      var idx = Number(fs.getAttribute('data-option-index'));
      var check = function (value) {
        return variants.some(function (v) {
          if (!v.available) return false;
          return v.options.every(function (o, i) { return i === idx ? o === value : (i < idx ? o === selected[i] : true); });
        });
      };
      $$('input', fs).forEach(function (input) { input.classList.toggle('is-unavailable', !check(input.value)); });
      $$('option', fs).forEach(function (opt) {
        var ok = check(opt.value);
        opt.textContent = opt.value + (ok ? '' : ' — ' + T.strings.soldOut);
      });
    });
  };

  Product.prototype.onChange = function (e) {
    var t = e.target;
    if (!t.matches('input[type="radio"], select')) return;
    var fs = t.closest('[data-option-index]');
    var label = fs && fs.querySelector('[data-option-value]');
    if (label) label.textContent = t.value;
    var options = this.currentOptions();
    var variant = this.findVariant(options);
    this.markAvailability(options);
    this.updateVariant(variant);
    if (fs && fs.hasAttribute('data-color-option')) this.filterMedia(false);
  };

  Product.prototype.updateVariant = function (variant) {
    var el = this.el;
    var s = T.strings;
    var btn = el.querySelector('[data-add-to-cart]');
    var btnText = el.querySelector('[data-add-to-cart-text]');
    var sticky = el.querySelector('[data-sticky-add]');
    var bis = el.querySelector('[data-back-in-stock]');
    this.variant = variant;

    if (!variant) {
      if (btn) btn.disabled = true;
      if (btnText) btnText.textContent = s.unavailable;
      if (sticky) { sticky.disabled = true; sticky.textContent = s.unavailable; }
      return;
    }
    if (this.idInput) this.idInput.value = variant.id;
    $$('form[action*="/cart/add"] input[name="id"]', el).forEach(function (i) { i.value = variant.id; });

    if (btn) btn.disabled = !variant.available;
    if (btnText) btnText.textContent = variant.available ? s.addToCart : s.soldOut;
    if (sticky) { sticky.disabled = !variant.available; sticky.textContent = variant.available ? s.addToCart : s.soldOut; }
    if (bis) {
      bis.classList.toggle('hidden', variant.available);
      var body = bis.querySelector('[data-bis-body]');
      if (body) body.value = body.value.split(' — ')[0] + ' — ' + variant.title;
    }

    // Price
    var priceWrap = el.querySelector('[data-product-price] [data-price]');
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var pct = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
    if (priceWrap) {
      var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
      if (onSale) html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s><span class="price__save">-' + pct + '%</span>';
      priceWrap.innerHTML = html;
      priceWrap.classList.toggle('price--sale', !!onSale);
    }
    var badge = el.querySelector('[data-sale-badge]');
    if (badge) { badge.hidden = !onSale; badge.textContent = '-' + pct + '%'; }
    var sp = el.querySelector('[data-sticky-price]');
    if (sp) sp.textContent = formatMoney(variant.price);
    var svt = el.querySelector('[data-sticky-variant-title]');
    if (svt && this.product.variants.length > 1) svt.textContent = variant.options.join(' • ') + ' · ';

    // SKU
    var sku = el.querySelector('[data-sku]');
    if (sku) { sku.textContent = variant.sku || ''; var w = el.querySelector('[data-sku-wrap]'); if (w) w.hidden = !variant.sku; }

    // Stock
    var stock = el.querySelector('[data-stock]');
    if (stock) {
      var qty = this.inventory[variant.id];
      var threshold = Number(stock.getAttribute('data-threshold'));
      var showCount = stock.getAttribute('data-show-count') === 'true';
      if (!variant.available) stock.innerHTML = '<span class="stock__dot stock__dot--out"></span>' + s.soldOut;
      else if (qty != null && qty > 0 && qty <= threshold) {
        stock.innerHTML = '<span class="stock__dot stock__dot--low"></span>' + (showCount ? s.lowStock.replace('[count]', qty) : s.lowStockNoCount) +
          '<span class="stock__bar"><span style="width:' + Math.round(qty * 100 / threshold) + '%"></span></span>';
      }
      else if (showCount && qty != null && qty > 0) stock.innerHTML = '<span class="stock__dot"></span>' + s.inStockCount.replace('[count]', qty);
      else stock.innerHTML = '<span class="stock__dot"></span>' + s.inStock;
    }

    // Media
    if (variant.featured_media && this.gallery) this.gallery.goToMedia(variant.featured_media.id);

    this.updateBreaks();

    if (this.opts.updateUrl !== false && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  /* ---------- Gallery ---------- */
  Product.prototype.initGallery = function () {
    var self = this;
    var root = this.el.querySelector('[data-gallery]');
    if (!root) return;
    var track = root.querySelector('[data-gallery-track]');
    var slides = $$('.gallery__slide', track);
    var thumbsWrap = root.querySelector('[data-gallery-thumbs]');
    var thumbs = $$('[data-thumb]', root);
    var counter = root.querySelector('[data-gallery-current]');
    var totalEl = root.querySelector('[data-gallery-total]');
    var progress = root.querySelector('[data-gallery-progress]');
    var isGrid = function () { return (root.classList.contains('gallery--grid') || root.classList.contains('gallery--stacked')) && mqDesktop.matches; };
    var visible = function () { return slides.filter(function (s) { return !s.classList.contains('is-filtered'); }); };
    var index = 0;

    function setActive(i) {
      var vis = visible();
      if (!vis.length) return;
      index = Math.max(0, Math.min(i, vis.length - 1));
      var current = vis[index];
      slides.forEach(function (s) {
        var on = s === current;
        s.classList.toggle('is-active', on);
        var v = s.querySelector('video');
        if (v && !on && !isGrid()) v.pause();
      });
      var ci = slides.indexOf(current);
      thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.getAttribute('data-thumb')) === ci); });
      var at = thumbs.find(function (t) { return Number(t.getAttribute('data-thumb')) === ci; });
      if (at && thumbsWrap) {
        var horizontal = thumbsWrap.scrollWidth > thumbsWrap.clientWidth;
        if (horizontal) thumbsWrap.scrollTo({ left: at.offsetLeft - thumbsWrap.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
        else thumbsWrap.scrollTo({ top: at.offsetTop - thumbsWrap.clientHeight / 2 + at.clientHeight / 2, behavior: 'smooth' });
      }
      if (counter) counter.textContent = index + 1;
      if (totalEl) totalEl.textContent = vis.length;
      if (progress) progress.style.width = ((index + 1) / vis.length * 100) + '%';
    }

    function go(i, smooth) {
      var vis = visible();
      if (!vis.length) return;
      i = (i + vis.length) % vis.length;
      var target = vis[i];
      if (isGrid()) {
        var y = target.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 80) - 20;
        window.scrollTo({ top: y, behavior: smooth === false ? 'auto' : 'smooth' });
      } else {
        track.scrollTo({ left: target.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      }
      setActive(i);
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (isGrid()) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var vis = visible();
        var x = track.scrollLeft;
        var best = 0, dist = Infinity;
        vis.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - x); if (d < dist) { dist = d; best = k; } });
        if (best !== index) setActive(best);
      });
    }, { passive: true });

    $$('[data-gallery-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(index - 1); }); });
    $$('[data-gallery-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(index + 1); }); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = slides[Number(t.getAttribute('data-thumb'))];
        var i = visible().indexOf(slide);
        if (i > -1) go(i);
      });
    });

    // Grid mode: highlight thumb for the slide in view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!isGrid()) return;
        entries.forEach(function (en) { if (en.isIntersecting) setActive(visible().indexOf(en.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      slides.forEach(function (s) { io.observe(s); });
    }

    // Hover magnifier
    if (root.getAttribute('data-zoom') === 'hover') {
      $$('.gallery__zoom', root).forEach(function (z) {
        var img = z.querySelector('img');
        if (!img) return;
        z.addEventListener('mousemove', function (e) {
          if (!finePointer.matches) return;
          var r = z.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          z.classList.add('is-zoomed');
        });
        z.addEventListener('mouseleave', function () { z.classList.remove('is-zoomed'); });
      });
    }

    // Lightbox
    $$('[data-lightbox-open]', root).forEach(function (b) {
      var open = function () {
        var lb = self.el.querySelector('[data-lightbox]');
        if (lb) openLightbox(lb, b.getAttribute('data-lightbox-open'));
      };
      b.addEventListener('click', open);
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });

    var startSlide = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (startSlide > 0) requestAnimationFrame(function () { go(startSlide, false); }); else setActive(0);

    this.gallery = {
      root: root, slides: slides, thumbs: thumbs,
      refresh: function () { setActive(0); go(0, false); },
      goToMedia: function (id) {
        var slide = slides.find(function (s) { return String(s.getAttribute('data-media-id')) === String(id); });
        var i = visible().indexOf(slide);
        if (i > -1) go(i);
      }
    };
  };

  /* Variant-based media: show images whose alt text matches selected colour */
  Product.prototype.filterMedia = function (initial) {
    if (!this.gallery || !this.gallery.root.hasAttribute('data-variant-media') || !this.picker) return;
    var colorFs = this.picker.querySelector('[data-color-option]');
    if (!colorFs) return;
    var values = $$('input, option', colorFs).map(function (i) { return i.value.toLowerCase().trim(); });
    var checked = colorFs.querySelector('input:checked') || colorFs.querySelector('select');
    if (!checked) return;
    var current = checked.value.toLowerCase().trim();
    var g = this.gallery;
    var hasMatch = g.slides.some(function (s) { return s.getAttribute('data-alt') === current; });
    if (!hasMatch) { g.slides.concat(g.thumbs).forEach(function (n) { n.classList.remove('is-filtered'); }); return; }
    var hide = function (n) { var a = n.getAttribute('data-alt'); return values.indexOf(a) > -1 && a !== current; };
    g.slides.forEach(function (s) { s.classList.toggle('is-filtered', hide(s)); });
    g.thumbs.forEach(function (t) { t.classList.toggle('is-filtered', hide(t)); });
    g.refresh();
  };

  var activeLightbox = null;
  function openLightbox(lb, idx) {
    activeLightbox = lb;
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var target = lb.querySelector('[data-lightbox-item="' + idx + '"]');
    setTimeout(function () { if (target) target.scrollIntoView(); }, 30);
  }
  function closeLightbox() {
    if (!activeLightbox) return;
    activeLightbox.classList.remove('is-open');
    activeLightbox.setAttribute('aria-hidden', 'true');
    activeLightbox = null;
    if (!openLayers.length) document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lightbox-close]') || e.target.closest('.lightbox__item img')) closeLightbox();
  });

  /* Quantity */
  Product.prototype.initQty = function () {
    $$('[data-qty]', this.el).forEach(function (q) {
      var input = q.querySelector('[data-qty-input]');
      q.addEventListener('click', function (e) {
        if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        else if (e.target.closest('[data-qty-plus]')) input.value = (parseInt(input.value, 10) || 1) + 1;
        else return;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  /* Quantity breaks */
  Product.prototype.initBreaks = function () {
    var wrap = this.el.querySelector('[data-qty-breaks]');
    if (!wrap) return;
    var self = this;
    this.breaks = wrap;
    var sync = function () {
      var checked = wrap.querySelector('input:checked');
      $$('.qty-break', wrap).forEach(function (l) { l.classList.toggle('is-active', l.contains(checked)); });
      if (checked) $$('[data-qty-input]', self.el).forEach(function (i) { i.value = checked.value; });
    };
    wrap.addEventListener('change', sync);
    sync();
  };
  Product.prototype.updateBreaks = function () {
    if (!this.breaks || !this.variant) return;
    var price = this.variant.price;
    $$('.qty-break', this.breaks).forEach(function (l) {
      var input = l.querySelector('input');
      var qty = Number(input.value), disc = Number(input.getAttribute('data-discount')) || 0;
      var full = price * qty;
      var total = Math.round(full * (100 - disc) / 100);
      var t = l.querySelector('[data-break-total]'), f = l.querySelector('[data-break-full]');
      if (t) t.textContent = formatMoney(total);
      if (f) f.textContent = formatMoney(full);
    });
  };

  /* Gift toggle */
  Product.prototype.initGift = function () {
    var g = this.el.querySelector('[data-gift-toggle]');
    if (!g) return;
    var input = g.querySelector('input');
    var sync = function () { g.classList.toggle('is-on', input.checked); };
    input.addEventListener('change', sync);
    sync();
  };

  /* Complementary products */
  Product.prototype.initComplementary = function () {
    var c = this.el.querySelector('[data-complementary]');
    if (!c) return;
    fetch(c.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = doc.querySelector('.complementary__items');
      if (items && items.children.length) { c.querySelector('[data-complementary-list]').innerHTML = items.innerHTML; c.classList.add('is-loaded'); }
    }).catch(function () {});
  };

  /* Sticky add to cart */
  Product.prototype.initSticky = function () {
    var bar = this.el.querySelector('[data-sticky-atc]');
    var main = this.el.querySelector('.product-form__submit');
    if (!bar || !main) return;
    var btn = bar.querySelector('[data-sticky-add]');
    var form = main.closest('form');
    btn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
    var footer = document.querySelector('.site-footer');
    var mainVisible = true, footerVisible = false;
    var update = function () {
      var show = !mainVisible && !footerVisible && main.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    new IntersectionObserver(function (entries) { mainVisible = entries[0].isIntersecting; update(); }).observe(main);
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
  };

  /* Delivery estimate */
  Product.prototype.initDelivery = function () {
    var d = this.el.querySelector('[data-delivery]');
    if (!d) return;
    var min = Number(d.getAttribute('data-min')), max = Number(d.getAttribute('data-max')), cutoff = Number(d.getAttribute('data-cutoff'));
    function addBusinessDays(date, n) {
      var r = new Date(date);
      while (n > 0) { r.setDate(r.getDate() + 1); var day = r.getDay(); if (day !== 0 && day !== 6) n--; }
      return r;
    }
    var render = function () {
      var now = new Date();
      var start = new Date(now);
      if (now.getHours() >= cutoff) start.setDate(start.getDate() + 1);
      var opts = { weekday: 'short', day: 'numeric', month: 'short' };
      var locale = document.documentElement.lang || undefined;
      var a = addBusinessDays(start, min).toLocaleDateString(locale, opts);
      var b = addBusinessDays(start, max).toLocaleDateString(locale, opts);
      var out = d.querySelector('[data-delivery-dates]');
      if (out) out.textContent = min === max ? a : a + ' – ' + b;
      var cut = d.querySelector('[data-delivery-cutoff]');
      if (cut) {
        var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
        var diff = end - now;
        if (diff > 0 && now.getDay() !== 0 && now.getDay() !== 6) {
          var h = Math.floor(diff / 36e5), m = Math.floor(diff / 6e4) % 60;
          cut.textContent = ' · ' + cut.getAttribute('data-label') + ' ' + h + 'h ' + m + 'm';
        } else cut.textContent = '';
      }
    };
    render();
    setInterval(render, 60000);
  };

  /* Recently viewed */
  Product.prototype.trackRecentlyViewed = function () {
    var handle = this.el.getAttribute('data-handle');
    if (!handle) return;
    var list = store.get('maison:recent') || [];
    list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
    store.set('maison:recent', list);
  };

  function initRecentlyViewed(root) {
    $$('[data-recently-viewed]', root).forEach(function (sec) {
      var track = sec.querySelector('[data-recently-viewed-track]');
      var ps = document.querySelector('.product-section[data-handle]');
      var current = ps ? ps.getAttribute('data-handle') : null;
      var limit = Number(sec.getAttribute('data-limit')) || 6;
      var list = (store.get('maison:recent') || []).filter(function (h) { return h !== current; }).slice(0, limit);
      if (!list.length) return;
      Promise.all(list.map(function (h) {
        return fetch(T.routes.root.replace(/\/$/, '') + '/products/' + h + '?section_id=card-render')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var out = '';
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var item = doc.querySelector('.grid-item');
          if (item) out += item.outerHTML;
        });
        if (out) { track.innerHTML = out; sec.classList.remove('hidden'); initCarousels(sec); }
      });
    });
  }

  /* ==========================================================================
     COMPONENTS
     ========================================================================== */
  /* Move overlays out of sticky/transformed ancestors so they sit above the page overlay */
  function portal(root) {
    $$('[data-portal]', root).forEach(function (el) {
      if (el.parentNode === document.body) return;
      if (el.id) {
        var old = document.getElementById(el.id);
        while (old && old !== el) { old.remove(); old = document.getElementById(el.id); }
      }
      document.body.appendChild(el);
    });
  }

  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var setH = function () { document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); };
    setH();
    window.addEventListener('resize', setH);
    if (header.hasAttribute('data-transparent')) {
      var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0, speed = (Number(bar.getAttribute('data-speed')) || 5) * 1000, timer;
      function go(n) {
        items[i].classList.remove('is-active'); items[i].classList.add('is-leaving');
        var old = items[i]; setTimeout(function () { old.classList.remove('is-leaving'); }, 500);
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      function play() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); }
      var p = bar.querySelector('[data-announcement-prev]'), n = bar.querySelector('[data-announcement-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); play(); });
      if (n) n.addEventListener('click', function () { go(i + 1); play(); });
      play();
    });
  }

  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      var raw = el.getAttribute('data-countdown');
      if (!raw) return;
      var end = new Date(raw.replace(' ', 'T'));
      if (isNaN(end)) return;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        var diff = Math.max(0, end - new Date());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        var set = function (sel, v) { var x = el.querySelector(sel); if (x) x.textContent = pad(v); };
        set('[data-days]', d); set('[data-hours]', h); set('[data-minutes]', m); set('[data-seconds]', s);
        if (diff <= 0) {
          clearInterval(iv);
          var txt = el.getAttribute('data-expired-text');
          if (txt) el.innerHTML = '<p>' + txt + '</p>';
          else if (el.hasAttribute('data-compact') || el.hasAttribute('data-hide-expired')) el.style.display = 'none';
        }
      };
      var iv = setInterval(tick, 1000);
      tick();
    });
  }

  function initSlideshows(root) {
    $$('[data-slideshow]', root).forEach(function (ss) {
      var slides = $$('[data-slide]', ss);
      var dots = $$('[data-slide-dot]', ss);
      if (slides.length < 2) return;
      var i = 0, timer;
      var autoplay = ss.getAttribute('data-autoplay') === 'true';
      var speed = (Number(ss.getAttribute('data-speed')) || 6) * 1000;
      ss.style.setProperty('--slide-speed', speed / 1000 + 's');
      function go(n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) { dots[i].classList.add('is-active'); dots[i].classList.toggle('is-static', !autoplay); }
        var v = slides[i].querySelector('video'); if (v) v.play().catch(function () {});
      }
      function play() { if (!autoplay) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-slide-dot'))); play(); }); });
      var p = ss.querySelector('[data-slide-prev]'), n = ss.querySelector('[data-slide-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); play(); });
      if (n) n.addEventListener('click', function () { go(i + 1); play(); });
      var sx = null;
      ss.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      ss.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) { go(i + (dx < 0 ? 1 : -1)); play(); }
        sx = null;
      });
      if (!autoplay && dots[0]) dots[0].classList.add('is-static');
      play();
      ss._goTo = function (n) { go(n); clearInterval(timer); };
    });
  }

  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (c) {
      if (c._init) return; c._init = true;
      var track = c.querySelector('[data-carousel-track]');
      var prev = c.querySelector('[data-carousel-prev]'), next = c.querySelector('[data-carousel-next]');
      if (!track) return;
      var step = function () { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : track.clientWidth; };
      var update = function () {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (wrap) {
      var btns = $$('[data-tab]', wrap);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var idx = b.getAttribute('data-tab');
          btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
          $$('[data-tab-panel]', wrap).forEach(function (p) {
            var on = p.getAttribute('data-tab-panel') === idx;
            p.classList.toggle('is-active', on);
            if (on) $$('.reveal', p).forEach(function (r) { r.classList.add('is-in'); });
          });
        });
      });
    });
  }

  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function splitHeadings(root) {
    var b = document.body;
    if (!b.classList.contains('heading-anim-words') && !b.classList.contains('heading-anim-flash')) return;
    var sel = '.section-head h2, [data-split], .image-text__content h2, .rich-text h2, .countdown-banner__content h2, .newsletter__inner h2, .banner .display, .collection-hero h1';
    $$(sel, root).forEach(function (h) {
      if (h.classList.contains('is-split') || h.closest('.slide')) return;
      var w = 0;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var parts = child.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            parts.forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
              var outer = document.createElement('span'); outer.className = 'split-w';
              var inner = document.createElement('span'); inner.textContent = p; inner.style.setProperty('--w', w++);
              outer.appendChild(inner); frag.appendChild(outer);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            walk(child);
          }
        });
      };
      walk(h);
      h.classList.add('is-split');
      if (revealObserver) revealObserver.observe(h); else h.classList.add('is-in');
    });
  }

  function initReveal(root) {
    splitHeadings(root);
    $$('.reveal:not(.is-in), .reveal-clip:not(.is-in)', root).forEach(function (el) {
      if (revealObserver) revealObserver.observe(el); else el.classList.add('is-in');
    });
  }

  function initFloating() {
    var secs = $$('[data-floating]');
    if (!secs.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    var run = function () {
      secs.forEach(function (sec) {
        var r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = (r.top + r.height / 2 - window.innerHeight / 2);
        $$('[data-float-speed]', sec).forEach(function (img) {
          img.style.setProperty('--float-y', (p * Number(img.getAttribute('data-float-speed'))).toFixed(1) + 'px');
        });
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(run); ticking = true; } }, { passive: true });
    run();
  }

  function initParallax() {
    var items = $$('.banner--parallax');
    if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    var run = function () {
      items.forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        b.style.setProperty('--parallax', (p * -80 - 8) + 'px');
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(run); ticking = true; } }, { passive: true });
    run();
  }

  function initShopTheLook(root) {
    $$('[data-shop-look]', root).forEach(function (sec) {
      var spots = $$('[data-hotspot]', sec), items = $$('[data-hotspot-item]', sec);
      var cur = sec.querySelector('[data-look-current]');
      var i = 0;
      function go(n) {
        i = (n + items.length) % items.length;
        spots.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        items.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        if (cur) cur.textContent = i + 1;
      }
      spots.forEach(function (s) { s.addEventListener('click', function () { go(Number(s.getAttribute('data-hotspot'))); }); });
      var p = sec.querySelector('[data-look-prev]'), n = sec.querySelector('[data-look-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (n) n.addEventListener('click', function () { go(i + 1); });
    });
  }

  function initVideos(root) {
    $$('[data-video-poster]', root).forEach(function (p) {
      p.addEventListener('click', function () {
        var type = p.getAttribute('data-type'), id = p.getAttribute('data-id');
        var src = type === 'youtube'
          ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1'
          : 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        p.outerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="Video"></iframe>';
      }, { once: true });
    });
  }

  function initCardSwatches() {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('.card-swatches .swatch, .card-hover-swatches .swatch');
      if (!sw) return;
      var card = sw.closest('[data-product-card]');
      var src = sw.getAttribute('data-swatch-image');
      var img = card && card.querySelector('.product-card__img--primary');
      if (!img || !src) return;
      $$('.swatch', card).forEach(function (s) { s.classList.toggle('is-active', s === sw); });
      img.removeAttribute('srcset');
      img.src = src;
    });
  }

  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.children.length && el.querySelector('.carousel')) { initCarousels(el); return; }
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initCarousels(el); }
      });
    });
  }

  /* ---------- Collection filters ---------- */
  function initCollection(root) {
    var sec = (root || document).querySelector('[data-collection-section]');
    if (!sec) return;
    var sectionId = sec.getAttribute('data-section-id');

    function applyCols() {
      var cols = store.get('maison:cols');
      var grid = sec.querySelector('[data-product-grid]');
      if (!grid || !cols || window.innerWidth < 990) return;
      grid.style.setProperty('--cols', cols);
      $$('[data-grid-toggle] button', sec).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cols') === String(cols)); });
    }

    function load(url, push) {
      var content = sec.querySelector('[data-collection-content]');
      var drawerOpen = !!sec.querySelector('#FilterDrawer.is-open');
      content.classList.add('is-loading');
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-collection-content]');
        if (!fresh) { window.location.href = url; return; }
        // preserve open accordions
        var openGroups = $$('#FilterDrawer details', content).map(function (d) { return d.open; });
        openLayers = openLayers.filter(function (l) { return l.id !== 'FilterDrawer'; });
        content.innerHTML = fresh.innerHTML;
        content.classList.remove('is-loading');
        var drawer = content.querySelector('#FilterDrawer');
        $$('#FilterDrawer details', content).forEach(function (d, k) { if (openGroups[k] === false) d.open = false; });
        if (drawerOpen && drawer) {
          drawer.style.transition = 'none';
          openLayer(drawer);
          requestAnimationFrame(function () { drawer.style.transition = ''; });
        } else { unlock(); }
        applyCols();
        initReveal(content);
        if (push) {
          var clean = new URL(url, window.location.origin); clean.searchParams.delete('section_id');
          history.pushState({ facets: true }, '', clean.toString());
        }
      }).catch(function () { window.location.href = url; });
    }

    function formUrl(form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var sort = sec.querySelector('[data-sort]');
      if (sort) params.set('sort_by', sort.value);
      return window.location.pathname + '?' + params.toString();
    }

    var debounce;
    sec.addEventListener('change', function (e) {
      if (e.target.closest('[data-facets-form]') || e.target.matches('[data-sort]')) {
        var form = sec.querySelector('[data-facets-form]');
        clearTimeout(debounce);
        debounce = setTimeout(function () { load(formUrl(form), true); }, e.target.type === 'number' ? 600 : 50);
      }
    });
    sec.addEventListener('submit', function (e) {
      if (e.target.matches('[data-facets-form]')) { e.preventDefault(); load(formUrl(e.target), true); }
    });
    sec.addEventListener('click', function (e) {
      var link = e.target.closest('[data-filter-link]');
      if (link) { e.preventDefault(); load(link.href, true); return; }
      var col = e.target.closest('[data-grid-toggle] button');
      if (col) { store.set('maison:cols', Number(col.getAttribute('data-cols'))); applyCols(); return; }
      var more = e.target.closest('[data-load-more-btn]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-loading');
        var u = new URL(more.href, window.location.origin);
        u.searchParams.set('section_id', sectionId);
        fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelector('[data-grid-items]');
          var grid = sec.querySelector('[data-grid-items]');
          if (items && grid) {
            var frag = document.createDocumentFragment();
            $$('.grid-item', items).forEach(function (it) { frag.appendChild(it); });
            grid.appendChild(frag);
          }
          var lm = doc.querySelector('[data-load-more]'), cur = sec.querySelector('[data-load-more]');
          if (lm && cur) cur.outerHTML = lm.outerHTML;
          initReveal(sec);
        });
      }
    });
    window.addEventListener('popstate', function (e) { if (e.state && e.state.facets) load(window.location.href, false); });
    applyCols();
  }

  /* ---------- Newsletter popup ---------- */
  function initPopup() {
    var p = $('[data-newsletter-popup]');
    if (!p) return;
    var test = p.getAttribute('data-test') === 'true';
    if (window.location.search.indexOf('customer_posted=true') > -1 && window.location.hash.indexOf('PopupNewsletter') > -1) { openLayer(p); return; }
    if (!test && store.get('maison:popup')) return;
    setTimeout(function () {
      if (openLayers.length) return;
      openLayer(p);
      store.set('maison:popup', Date.now());
    }, (Number(p.getAttribute('data-delay')) || 8) * 1000);
  }

  /* ---------- Misc ---------- */
  function initBackToTop() {
    var b = $('[data-back-to-top]');
    if (!b) return;
    var ring = b.querySelector('[data-back-to-top-ring]');
    var ticking = false;
    var update = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      b.classList.toggle('is-visible', window.scrollY > 600);
      if (ring) ring.style.strokeDashoffset = String(100 - p * 100);
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }
  function initFooterAccordions() {
    if (window.matchMedia('(max-width: 749px)').matches) {
      $$('.footer-accordion').forEach(function (d) { d.removeAttribute('open'); });
    } else {
      $$('.footer-accordion > summary').forEach(function (s) { s.addEventListener('click', function (e) { e.preventDefault(); }); });
    }
  }

  function initProducts(root) {
    $$('[data-product-section]', root).forEach(function (el) {
      if (el._product) return;
      el._product = new Product(el, { updateUrl: el.classList.contains('product-section') });
    });
  }

  function initPtabs(root) {
    $$('[data-ptabs]', root).forEach(function (sec) {
      var tabs = $$('[data-ptab]', sec), panels = $$('[data-ptab-panel]', sec);
      var show = function (i) {
        tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
      };
      tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      sec._show = show;
    });
  }

  function initAll(root) {
    portal(root);
    initTypedSearch(root);
    initShowcase(root);
    initLookBanner(root);
    initLookbook(root);
    initPtabs(root);
    initAnnouncement(root);
    initCountdowns(root);
    initSlideshows(root);
    initCarousels(root);
    initTabs(root);
    initReveal(root);
    initShopTheLook(root);
    initVideos(root);
    initProducts(root);
    initRecommendations(root);
    initRecentlyViewed(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initAll(document);
    initCollection(document);
    initParallax();
    initFloating();
    initHeroMq();
    initMenuPanels();
    initCardSwatches();
    initPopup();
    initBackToTop();
    initFooterAccordions();
  });


  /* ---------- v4: Sky home interactions ---------- */
  function initTypedSearch(root) {
    $$('[data-typed]', root).forEach(function (btn) {
      if (btn._typed) return; btn._typed = true;
      var words = (btn.getAttribute('data-typed') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      var out = btn.querySelector('[data-typed-text]');
      if (!words.length || !out || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var base = out.textContent.replace(/\.+$/, '').trim();
      var wi = 0, ci = 0, deleting = false;
      var tick = function () {
        var w = words[wi];
        ci += deleting ? -1 : 1;
        out.textContent = base + ' ' + w.slice(0, ci);
        var delay = deleting ? 45 : 95;
        if (!deleting && ci === w.length) { deleting = true; delay = 1400; }
        else if (deleting && ci === 0) { deleting = false; wi = (wi + 1) % words.length; delay = 300; }
        setTimeout(tick, delay);
      };
      setTimeout(tick, 1200);
    });
  }

  function initHeroMq() {
    var heroes = $$('[data-hero-mq]');
    if (!heroes.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    var run = function () {
      heroes.forEach(function (h) {
        var r = h.getBoundingClientRect();
        if (r.bottom < 0) return;
        var p = Math.min(1, Math.max(0, -r.top / r.height));
        var media = h.querySelector('[data-hero-media]');
        if (media) media.style.transform = 'translateY(' + (p * 18) + '%) scale(' + (1 + p * 0.08) + ')';
        h.style.setProperty('--hero-p', p.toFixed(3));
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(run); ticking = true; } }, { passive: true });
    run();
  }

  function initShowcase(root) {
    $$('[data-showcase]', root).forEach(function (sec) {
      if (sec._init) return; sec._init = true;
      var names = $$('[data-showcase-name]', sec), slides = $$('[data-showcase-slide]', sec);
      if (!names.length) return;
      var i = 0, timer, interval = (Number(sec.getAttribute('data-interval')) || 4) * 1000;
      var show = function (n) {
        i = (n + names.length) % names.length;
        names.forEach(function (b, k) { b.classList.toggle('is-active', k === i); b.classList.toggle('is-prev', k === (i - 1 + names.length) % names.length); b.classList.toggle('is-next', k === (i + 1) % names.length); });
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      };
      var play = function () { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, interval); };
      names.forEach(function (b, k) { b.addEventListener('click', function () { show(k); play(); }); b.addEventListener('mouseenter', function () { show(k); play(); }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { if (en[0].isIntersecting) play(); else clearInterval(timer); }).observe(sec);
      } else play();
      show(0);
      sec._show = show;
    });
  }

  function initLookBanner(root) {
    $$('[data-look-banner]', root).forEach(function (sec) {
      if (sec._init) return; sec._init = true;
      var dots = $$('[data-look-dot]', sec), cards = $$('[data-look-card]', sec);
      var cur = sec.querySelector('[data-look-current]');
      var i = 0;
      var show = function (n) {
        if (!cards.length) return;
        i = (n + cards.length) % cards.length;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        cards.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
        if (cur) cur.textContent = i + 1;
      };
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); sec.querySelector('[data-look-panel]').classList.add('is-open'); }); });
      var p = sec.querySelector('[data-look-prev]'), n = sec.querySelector('[data-look-next]');
      if (p) p.addEventListener('click', function () { show(i - 1); });
      if (n) n.addEventListener('click', function () { show(i + 1); });
      var t = sec.querySelector('[data-look-toggle]');
      if (t) t.addEventListener('click', function () { sec.querySelector('[data-look-panel]').classList.toggle('is-open'); });
      sec._show = show;
    });
  }

  function initLookbook(root) {
    $$('[data-lookbook]', root).forEach(function (sec) {
      if (sec._init) return; sec._init = true;
      var models = $$('[data-lookbook-model]', sec);
      if (models.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        models[i].classList.remove('is-active');
        i = (i + 1) % models.length;
        models[i].classList.add('is-active');
      }, 3200);
    });
  }

  function initMenuPanels() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-drawer-open="MenuDrawer"]')) return;
      $$('[data-menu-drawer] [data-menu-panel]').forEach(function (p) {
        var root = p.getAttribute('data-menu-panel') === 'root';
        p.classList.toggle('is-active', root); p.classList.remove('is-behind');
      });
    });
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-menu-open]');
      var back = e.target.closest('[data-menu-back]');
      if (!open && !back) return;
      var drawer = (open || back).closest('[data-menu-drawer]');
      if (!drawer) return;
      var target = open ? open.getAttribute('data-menu-open') : 'root';
      $$('[data-menu-panel]', drawer).forEach(function (p) {
        var on = p.getAttribute('data-menu-panel') === target;
        p.classList.toggle('is-active', on);
        p.classList.toggle('is-behind', !on && p.getAttribute('data-menu-panel') === 'root' && target !== 'root');
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    });
    document.addEventListener('click', function (e) {
      $$('.gal-card__panel[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initCollection(e.target);
    if (e.target.querySelector('[data-header]')) initHeader();
    var popup = e.target.querySelector('[data-newsletter-popup]');
    if (popup) openLayer(popup);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var sc = e.target.closest('[data-showcase-name]');
    if (sc) { var ssec = sc.closest('[data-showcase]'); if (ssec && ssec._show) ssec._show(Number(sc.getAttribute('data-showcase-name'))); }
    var tab = e.target.closest('[data-ptab]');
    if (tab) { var sec = tab.closest('[data-ptabs]'); if (sec && sec._show) sec._show(Number(tab.getAttribute('data-ptab'))); }
    var slide = e.target.closest('[data-slide]');
    if (slide) {
      var ss = slide.closest('[data-slideshow]');
      var idx = $$('[data-slide]', ss).indexOf(slide);
      if (ss && ss._goTo) ss._goTo(idx);
    }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openLayer(e.target.querySelector('[data-cart-drawer]'));
  });

  window.Maison = { addToCart: addToCart, refreshCart: refreshCart, formatMoney: formatMoney, openCart: function () { openLayer($('[data-cart-drawer]')); } };
})();
